var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.467mm",
    height: "8.467mm",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,4.888H16.533V3.362a1.5,1.5,0,0,0-1.5-1.5H9.046a1.5,1.5,0,0,0-1.5,1.5V4.888H3v1.5H4.532V19.7a2.33,2.33,0,0,0,2.2,2.438h10.6a2.329,2.329,0,0,0,2.2-2.438V6.388H21ZM9.046,3.362h5.987V4.888H9.046ZM18.032,19.7c0,.508-.319.938-.7.938H6.729c-.378,0-.7-.43-.7-.938V6.388h12Zm-7.486-9.559v7.5a.75.75,0,0,1-1.5,0v-7.5a.75.75,0,1,1,1.5,0Zm4.5,0v7.5a.75.75,0,0,1-1.5,0v-7.5a.75.75,0,1,1,1.5,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.056c053e.svg";
export { ForwardRef as ReactComponent };